import { useState } from 'react'

import { F0Dialog } from '@factorialco/f0-react'
import {
  AtsHiringPlanRejectRequisitionDocument,
  AtsHiringPlanRequisitionDetailDocument,
} from 'generated/resources/graphql'

import TextArea from 'modules/core/components/TextArea'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

interface Props {
  requisitionId: string
  onClose: () => void
}

export const RejectRequisitionDialog = ({ requisitionId, onClose }: Props) => {
  const {
    access: { id: accessId },
  } = useCurrentSession()
  const [reason, setReason] = useState('')

  const [rejectMutation, { loading }] = useMutation(AtsHiringPlanRejectRequisitionDocument, {
    extractorFn: (data) => data.atsMutations.rejectAtsRequisition,
    refetchQueries: [AtsHiringPlanRequisitionDetailDocument],
  })

  const handleReject = async () => {
    const result = await rejectMutation({
      variables: {
        id: requisitionId,
        approverId: accessId,
        reason,
      },
    })

    const handled = handleResult(result, () => {
      app.setFlash({
        type: 'wrong',
        message: i18n.t('ats.vacancies_requisition_page.requisition_detail.actions.error'),
      })
    })

    if (handled.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('ats.vacancies_requisition_page.requisition_detail.reject_modal.rejected'),
      })
      onClose()
    }
  }

  return (
    <F0Dialog
      isOpen
      onClose={onClose}
      title={i18n.t('ats.vacancies_requisition_page.requisition_detail.reject_modal.title')}
      primaryAction={{
        label: i18n.t(
          'ats.vacancies_requisition_page.requisition_detail.reject_modal.reject_button'
        ),
        onClick: handleReject,
        disabled: loading,
      }}
      secondaryAction={{
        label: i18n.t('common.cancel'),
        onClick: onClose,
      }}
    >
      <TextArea
        label={i18n.t('ats.vacancies_requisition_page.requisition_detail.reject_modal.reason')}
        placeholder={i18n.t(
          'ats.vacancies_requisition_page.requisition_detail.reject_modal.reason_placeholder'
        )}
        value={reason}
        onChange={setReason}
      />
    </F0Dialog>
  )
}
